/* tslint:disable */
export const pt_overrides_strings = {
};
